// ------------------------------- //
//  Map UI Scale                   //
// ------------------------------- //
// texture 1 = vendor · 0.75 = calibrated look

export const MAP_UI_SCALE = 0.8

// ------------------------------------------------- //
//                                                   //
//                                                   //
//    Map Geographic Centers                         //
//                                                   //
//                                                   //
// ------------------------------------------------- //

export const MAP_CENTERS = {
  US_CENTER: { lat: 37.0902 as number, lng: -95.7129 as number },
  
  ORLANDO_CENTER: { lat: 28.5383 as number, lng: -81.3792 as number },
  
  DEFAULT: { lat: 37.0902 as number, lng: -95.7129 as number }
} as const

// ------------------------------------------------- //
//                                                   //
//                                                   //
//    Map Zoom Levels                                //
//                                                   //
//                                                   //
// ------------------------------------------------- //

export const MAP_ZOOM_LEVELS = {
  COUNTRY: 5,
  
  STATE: 8,
  
  CITY: 10,
  
  NEIGHBORHOOD: 12,
  
  STREET: 15,
  
  BUILDING: 18,
  
  DEFAULT: 10,
  
  MIN: 4,
  
  MAX: 20
} as const

// ------------------------------------------------- //
//                                                   //
//                                                   //
//    Map Control Configuration                      //
//                                                   //
//                                                   //
// ------------------------------------------------- //

export const MAP_CONTROLS = {
  CONTROL_SIZE: 22,
  
  POSITIONS: {
    TOP_LEFT: 1,
    TOP_CENTER: 2, 
    TOP_RIGHT: 3,
    LEFT_CENTER: 4,
    RIGHT_CENTER: 8,
    BOTTOM_LEFT: 6,
    BOTTOM_CENTER: 7,
    BOTTOM_RIGHT: 9
  },
  
  DEFAULTS: {
    mapTypeControl: {
      style: 1, // HORIZONTAL_BAR
      position: 1 // TOP_LEFT
    },
    zoomControl: {
      position: 8 // RIGHT_CENTER
    },
    streetViewControl: {
      position: 8 // RIGHT_CENTER
    },
    fullscreenControl: {
      position: 1 // TOP_LEFT
    }
  }
} as const

// ------------------------------------------------- //
//                                                   //
//                                                   //
//    Map Behavior Constants                         //
//                                                   //
//                                                   //
// ------------------------------------------------- //

export const MAP_BEHAVIOR = {
  GESTURE_HANDLING: 'greedy',
  
  BOUNDS_PADDING: 20,
  
  BOUNDS_PADDING_ENHANCED: 50,
  
  ANIMATION_DURATION: 300,
  
  DEBOUNCE_DELAY: 100
} as const

// ------------------------------------------------- //
//                                                   //
//                                                   //
//    Map Type Constants                             //
//                                                   //
//                                                   //
// ------------------------------------------------- //

export const MAP_TYPES = {
  ROADMAP: 'ROADMAP',
  SATELLITE: 'SATELLITE', 
  HYBRID: 'HYBRID',
  TERRAIN: 'TERRAIN'
} as const

// ------------------------------------------------- //
//                                                   //
//                                                   //
//    Environment-Specific Constants                //
//                                                   //
//                                                   //
// ------------------------------------------------- //

export const MAP_ENVIRONMENT = {
  DEFAULT_MAP_ID: import.meta.env.VITE_MAP_ID,
  
  API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY
} as const

// ------------------------------------------------- //
//                                                   //
//                                                   //
//    Convenience Combinations                       //
//                                                   //
//                                                   //
// ------------------------------------------------- //

export const DEFAULT_MAP_CONFIG = {
  center: MAP_CENTERS.DEFAULT,
  zoom: MAP_ZOOM_LEVELS.DEFAULT,
  mapType: MAP_TYPES.ROADMAP,
  controlSize: MAP_CONTROLS.CONTROL_SIZE,
  gestureHandling: MAP_BEHAVIOR.GESTURE_HANDLING,
  keyboardShortcuts: true,
  padding: MAP_BEHAVIOR.BOUNDS_PADDING
} as const

export const US_MAP_CONFIG = {
  center: MAP_CENTERS.US_CENTER,
  zoom: MAP_ZOOM_LEVELS.COUNTRY,
  mapType: MAP_TYPES.ROADMAP
} as const

export const ORLANDO_MAP_CONFIG = {
  center: MAP_CENTERS.ORLANDO_CENTER,
  zoom: MAP_ZOOM_LEVELS.STATE,
  mapType: MAP_TYPES.ROADMAP
} as const 